import { jsxs, jsx, Fragment } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { theme } from "../../../foundations/theme.es.js";
import { memo } from "react";
import { Typography } from "../../typography/typography.es.js";
function generateIseeCardTitle({
  title,
  icon
}) {
  const isIconSet = icon !== void 0;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    isIconSet && icon,
    /* @__PURE__ */ jsx(Typography, { sx: theme.typography.subtitle1, children: title })
  ] });
}
const IseeCardTitle = memo(generateIseeCardTitle);
export {
  IseeCardTitle
};
//# sourceMappingURL=isee-title.es.js.map
